export default __webpack_public_path__ + "static/media/Logout.7f48c9a0.svg";